import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Trans } from '@stepstone-platform/i18n';
import { Button, Stack, Text, TextLink } from '@stepstone-genesis/components';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { loginRecruiterShowLinkSelector, loginRecruiterUrlSelector, } from '../../../redux/core/siteConfig/siteConfigSlice.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { navigateToThunk } from '../../../redux/core/navigation/navigationSlice.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
export const LoginFooter = () => {
    const dispatch = useAppDispatch();
    const loginRecruiterUrl = useAppSelector(loginRecruiterUrlSelector);
    const loginRecruiterShowLink = useAppSelector(loginRecruiterShowLinkSelector);
    const { trackBtnClick } = useTrack('standard');
    const showRegistrationForm = () => {
        trackBtnClick({ uniqueName: 'switchToRegister' });
        dispatch(navigateToThunk(FORM_TYPES.REGISTRATION));
    };
    const onAreYouRecruiter = () => {
        trackBtnClick({ uniqueName: 'switchToRecruiter' });
    };
    return (_jsxs(Stack, { direction: "vertical", spacing: "spaceM", flxItems: "center", "data-testid": "login-footer", sx: { textAlign: 'center' }, children: [_jsx(Text, { fontSize: 'fontSizeM', children: _jsx(Trans, { i18nKey: 'loginregistration.login.dontHaveAccountQuestion', components: [
                        _jsx(Button, { a11yLabel: "singUpClick", "data-testid": "signup-link", variant: 'link', onClick: showRegistrationForm, px: '0px', pb: '1px', sx: {
                                height: '0px',
                            } }, "singUpClick"),
                    ] }) }), loginRecruiterShowLink && (_jsx(Text, { fontSize: 'fontSizeM', children: _jsx(Trans, { i18nKey: 'loginregistration.login.areYouARecruiterQuestion', components: [
                        _jsx(TextLink, { "data-testid": "recruiter-login-link", variant: "bare", href: loginRecruiterUrl, target: '_self', onClick: onAreYouRecruiter }, "recruiterLink"),
                    ] }) }))] }));
};
//# sourceMappingURL=LoginFooter.js.map